import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Datatable from "../../ExtraComponents/ReusableTable2";
import {
  lastFiveContract,
  deleteContract,
  createContract,
  downloadContract
} from "../../ReduxStore/Slice/Contract/contractSlice";

import { useDispatch } from "react-redux";
import { PenLine, Trash2 } from "lucide-react";
import { DateConvert, DateConvertWithTime } from "../../Utils/CommonFun";
import Swal from "sweetalert2";
import axios from "axios";
import { getDashboardData } from "../../ReduxStore/Slice/Dashboard/dashboardSlice";
import ReactPaginate from "react-paginate";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs from "dayjs"
import { DatePicker, Space, theme } from 'antd';

const QuotesDashboard = () => {
  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const userDetails = JSON.parse(localStorage.getItem("details"));
  const [lastFiveContractData, setLastFiveContractData] = useState([]);
  const [activeTab, setActiveTab] = useState("current-month");
  const [dashboard, setDashboard] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [isLoading, setLoading] = useState(false);
  const [range, setRange] = useState(null);

  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [InputValue, setInputValue] = useState('');


  const contract_created_amount = dashboard?.contract_created_list?.row_total

  const contract_sent_amount = dashboard?.contract_sent_list?.row_total

  const contract_unsent_amount = dashboard?.contract_unsent_list?.row_total

  const contract_reviewed_amount = dashboard?.contract_reviewed_list?.row_total

  const contract_signed_amount = dashboard?.contract_signed_list?.row_total

  const contract_declined_amount = dashboard?.contract_declined_list?.row_total


  //console.log("contractsSent_amount", contractsSent_amount);


  // Contract Dashboard Data
  const DashboardData = async () => {
    setLoading(true);
    let req = { agent_id: agent_id, filter: activeTab, link: "contract" };
    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }
    await dispatch(getDashboardData(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setDashboard(response.data);
          setTotalRecords(response?.pagination?.total || 0);
          setLoading(false);
        } else {
          setDashboard([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };



  useEffect(() => {
    DashboardData();
  }, [activeTab, range]);


  const handleTabChange = (event) => {
    setActiveTab(event.target.value);
  };


  // const handlePageChange = (page) => {
  //   setCurrentPage(page.selected + 1);
  // };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };


  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])

  useEffect(() => {
    getLastFiveContract();
  }, [currentPage, pageSize, InputValue, activeTab, range]);

  const getLastFiveContract = async () => {
    let req = { agent_id: agent_id, page: currentPage, limit: pageSize, search: InputValue, filter: activeTab };
    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }
    await dispatch(lastFiveContract(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setLastFiveContractData(response.data);
          setTotalRecords(response?.pagination?.total)

        } else {
          setLastFiveContractData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  const handleResendContract = async (row) => {
    // console.log("row handleResendContract", row);
    if (row.resend_contract_exist_data != null) {
      // Confirmation dialog
      Swal.fire({
        title: "Are you sure?",
        html: `<div>
           <div>Contract is already sent!</div>
           <div>Do you want to resend this contract?</div>
         </div>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Resend",
        cancelButtonText: "Cancel"
      }).then(async (result) => {
        if (result.isConfirmed) {

          // console.log("row.resend_contract_exist_data", JSON.parse(row.resend_contract_exist_data));
          let exist_send_data = JSON.parse(row.resend_contract_exist_data);

          // console.log("exist_send_data", exist_send_data.email_template_details);
          // console.log("exist_send_data clientid", exist_send_data.clientid);


          const req = {
            id: Number(exist_send_data.id),
            step: 4,
            mail_to: exist_send_data.mail_to,
            subject: exist_send_data.subject,
            template_id: exist_send_data.template_id,
            clientid: exist_send_data.clientid,
            ContractOwner: userDetails.id,
            agent_id: exist_send_data.agent_id,
            director_letter: exist_send_data.director_letter,
            self_assessment: exist_send_data.self_assessment,
            payment_type: exist_send_data.payment_type,
            cc_to: exist_send_data.cc_to || "",
            bcc_to: exist_send_data.bcc_to || "",
            email_template_details: exist_send_data.email_template_details

          }

          // console.log("req", req);
          setLoading(true);
          await dispatch(createContract(req)).unwrap()
            .then((res) => {
              if (res.status) {
                // console.log("res", res);
                //setLoading(false);
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: res.message,
                  timer: 3000,
                  timerProgressBar: true,
                });
                // setLoading(false);
                getLastFiveContract();
                return;
              }
              else {
                setLoading(false);
                if (res.message.includes("_____________")) {

                  Swal.fire({
                    icon: "warning",
                    title: "Warning..",
                    text: "Signature Tag Is Missing In The Document.",
                    timer: 3000,
                    timerProgressBar: true,
                  });
                  return;
                } else {

                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: res.message,
                    timer: 3000,
                    timerProgressBar: true,
                  })
                  return;
                }

              }
            }).catch((err) => {

              setLoading(false);
              console.log("err", err);
            })

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          return;
        }
      });

    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "This contract is not sent yet",
        background: "#fff",
        confirmButtonText: 'OK',
        showConfirmButton: true,
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
        timer: 3000,
      });
      return;
    }

  }

  const handleStopReminder = async (row) => {

    let stop_remainder_status = row.stop_remainder_status;
    let msg = "Stop";
    if (Number(row.stop_remainder_status) == 1) {
      stop_remainder_status = '0';
      msg = "Start";
    } else {
      stop_remainder_status = '1';
      msg = "Stop";
    }

    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${msg} reminder for this contract!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: msg + " Reminder",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, stop_remainder_status: stop_remainder_status, step: 5 };

        // console.log("req", req);
        await dispatch(createContract(req))
          .unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: "Success!",
                text: `Reminder ${msg} successfully.`,
                icon: "success",
                confirmButtonText: 'OK',
                showConfirmButton: true,

                timer: 3000,
              });
              getLastFiveContract();
            } else {
              Swal.fire("Error!", "Something went wrong.", "error");
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });

  }

  const columns = [
    {
      name: "Subject",
      selector: (row) => row?.subject == null || row?.subject == "" ? "-" : row?.subject,
      sortable: true,
    },
    {
      name: "Client",
      selector: (row) => row?.Client.client_name,
      sortable: true,
    },
    // {
    //   name: "Yearly Cost",
    //   selector: (row) => row?.yearly_cost,
    //   sortable: true,
    // },
    {
      name: "Created At",
      selector: (row) => DateConvertWithTime(row?.createdAt),
      sortable: true,
    },

    // {
    //   name: "Status",
    //   selector: (row) => Number(row?.contract_signed) === 1 ? "Contract Signed" :
    //     Number(row?.status) === 3 ? "Contract Reviewed" :
    //       Number(row?.step) === 4 ? "Contract Sent" :
    //         Number(row?.step) !== 4 ? "In Progress" :
    //           Number(row?.status) == 4 ? "Contract Declined" :
    //             "-",
    //   sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => {
        const contractSigned = Number(row?.contract_signed);
        const status = Number(row?.status);
        const step = Number(row?.step);

        if (contractSigned === 1) {
          return "Contract Signed";
        }

        if (status === 4) {
          return "Contract Declined";
        }

        if (status === 3) {
          return "Contract Reviewed";
        }

        if (step === 4) {
          return "Contract Sent";
        }

        // 👇 Yaha tum extra condition add kar sakte ho
        if (step !== 4 && status !== 4) {
          if (Number(row?.higher_discount_status) === 0 && Number(row?.request_higher_discount_ongoing) === 1) {
            return "Requested Higher Discount";
          }
          else if (Number(row?.higher_discount_status_oneoff) === 0 && Number(row?.request_higher_discount_oneoff) === 1) {
            return "Requested Higher Discount";
          }
          else if (Number(row?.higher_discount_status) === 1 || Number(row?.higher_discount_status_oneoff) === 1) {
            return "Discount Approved";
          }
          else if (Number(row?.higher_discount_status) === 2 || Number(row?.higher_discount_status_oneoff) === 2) {
            return "Discount Rejected";
          }
          else {
            return "In Progress";
          }
        }

        return "-";
      },
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          {/* Edit Button (hidden if step is 4) */}
          {Number(row?.step) === 4 ? (
            ""
          ) : (
            <button
              className="btn fs-4 py-0 px-1"
              onClick={() => handleEdit(row)}
              title="Edit"
            >
              <i className="ri-edit-line" />
            </button>
          )}

          {/* Delete Button */}
          <button
            className="btn fs-4 py-0 px-1"
            onClick={() => handleDelete(row)}
            title="Delete"
          >
            <i className="bx bx-trash" />
          </button>

          {/* Download/Convert Button */}
          <button
            className="btn fs-4 py-0 px-1"
            onClick={() => handleConvert(row)}
            title="Download Document"
          >
            <i className="ri-download-2-line" />
          </button>

          {/* Resend Contract Button with appropriate icon */}
          {Number(row?.step) !== 4 ?
            "" :
            <>
              <button
                className="btn fs-4 py-0 px-1"
                onClick={(e) => handleResendContract(row)}
                title="Resend Contract"
              >
                <i className="ri-send-plane-line" />
              </button>



              <button
                className="btn fs-4 py-0 px-1"
                onClick={() => handleStopReminder(row)}
                title={Number(row.stop_remainder_status) === 1 ? "Start Reminder" : "Stop Reminder"}
              >
                {/* <i className="ri-timer-line" /> */}
                <i
                  className={`ri-timer-line ${Number(row.stop_remainder_status) === 1 ? "text-danger" : "text-success"
                    }`}
                />
              </button>

            </>
          }




        </div>

      ),
      sortable: true,
    },
  ];

  const handleEdit = (row) => {
    nevigate("/admin/contracts/create-contract", { state: { row: row } });
  };

  const handleDelete = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this contract!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id };
        await dispatch(deleteContract(req))
          .unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: "Deleted!",
                text: "Your Contract has been deleted.",
                icon: "success",
                showConfirmButton: false,
                timer: 3000,
              });
              getLastFiveContract();
            } else {
              Swal.fire("Error!", "Something went wrong.", "error");
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your Contract is safe :)", "error");
      }
    });
  };

  const handleConvert = async (row) => {

    if (!row?.pendingId || !row?.orignalId || !row?.access_token) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please complete the contract first",

        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
      });
      return;
    }

    let req = { agent_id: agent_id, id: row?.id };
    await dispatch(downloadContract(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          // console.log("response.data-->>",response)
          let access_token = response.data
          setLoading(true);
          let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `https://api.signeasy.com/v3/rs/envelope/signed/${row.pendingId}/${row.orignalId}/download`,
            headers: {
              //Authorization: "Bearer " + row?.access_token,
              Authorization: "Bearer " + access_token,
            },
            responseType: "blob", // Important for binary PDF
          };

          axios
            .request(config)
            .then((response) => {
              setLoading(false);
              const blob = new Blob([response.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `${row.subject || "document"}.pdf`;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              setLoading(false);

              console.log("Download error:", error);
            });


        } else {

        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",

        customClass: {
          popup: "no-shadow",
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  const goToContracts = (val) => {
    nevigate("/admin/contracts/all-contracts", {
      state: {
        // range : range,
        range: range
          ? [
            range[0].toISOString(),
            range[1].toISOString()
          ]
          : null,
        activeTab: activeTab || "",
        contractTiles: val || ""
      }
    });
  };

  return (
    <div>
      <>
        <div className="row mb-3">
          <div className="col">
            <h4 className="page-title">Contracts</h4>
          </div>
          <div className="col-auto align-self-center">
            <Link
              to="/admin/contracts/create-contract"
              className="btn btn-pink"
              id="Dash_Date"
            >
              <span className="ay-name" id="Day_Name">
                Add New Contract
              </span>
            </Link>
          </div>
        </div>
        <div className="row"> <div className=" col-lg-3 filter-select mb-3">
          <data className=" datatable-search">
            <input
              type="text"
              className="search p-2 icon"
              placeholder="Search here"
              value={InputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </data>
        </div>
          <div className="col-lg-3 filter-select mb-3 select_tab">
            <select
              onChange={handleTabChange}
              value={activeTab}
              className="form-select"
            >
              <option value="current-month">Current Month</option>
              <option value="prev-month">Previous Month</option>
              <option value="current-quarter">Current Quarter</option>
              <option value="previous-quarter">Previous Quarter</option>
              <option value="current-calender-quarter">
                Current Calendar Year
              </option>
              <option value="prev-calender-year">Previous Calendar Year</option>
              <option value="custom-date">Custom Date</option>
            </select>
          </div>

          {activeTab === "custom-date" && (
            <div className=" d-flex gap-2  mb-3 col-lg-3 custom-datefilter">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DateRangePicker"]}>
                  <DatePicker.RangePicker
                    value={range}
                    onChange={setRange}
                    placeholder={['Start Date', 'End Date']}
                    format="DD/MM/YYYY"
                    className=""
                  />

                </DemoContainer>
              </LocalizationProvider>
            </div>
          )}


        </div>






        <section className="section dashboard">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">


                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToContracts("contract-created")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Contract Created</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.created || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{contract_created_amount?.toFixed(2) || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToContracts("contract-unsent")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Contract Unsent</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.unsent || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{contract_unsent_amount?.toFixed(2) || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToContracts("contract-sent")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Contract Sent</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.sent || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{contract_sent_amount?.toFixed(2) || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>



                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToContracts("contract-reviewed")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Contract Reviewed</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.reviewed || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{contract_reviewed_amount?.toFixed(2) || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToContracts("contract-signed")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Contract Signed</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.contract_signed || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{contract_signed_amount?.toFixed(2) || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToContracts("contract-declined")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Contract Declined</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.declined || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{contract_declined_amount?.toFixed(2) || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </section>
        <section className="section dashboard">
          <div className="table-main-div">
            <div className="table-recent-head-div">
              <div className="row">
                <div className="col">
                  <span className="text-pink font-16">Recent</span>
                </div>
                <div className="col-auto align-self-center">
                  <Link to="/admin/contracts/all-contracts">
                    <span className="text-pink font-16">See All</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <Datatable
                columns={columns}
                data={lastFiveContractData}
                filter={false}
              />

              {
                lastFiveContractData && lastFiveContractData.length > 0 ?
                  <>
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize) || 1}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />

                    <div className="mt-0">
                      <select className="perpage-select" value={pageSize} onChange={handlePageSizeChange}>
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={0}>{"ALL"}</option>
                      </select>
                    </div>
                  </>
                  :
                  null
              }

            </div>
          </div>
        </section>
      </>
    </div>
  );
};

export default QuotesDashboard;
